
import "./PatronArtistProfile.css";
import React, { useEffect, useState } from "react";
import { MdLocationOn } from "react-icons/md";
import {
  FaUser,
  FaInstagram,
  FaFacebook,
  FaYoutube,
  FaLinkedin,
  FaTwitter,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaGlobe,
  FaBriefcase,
  FaBook,
  FaNewspaper,
  FaSignOutAlt,
  FaIdBadge,
  FaTrophy,
  FaStar,
  FaArrowRight,
  FaImage,
  FaFilm, // Added for Video Header icon
  FaPlay, // Added for Video Play icon
} from "react-icons/fa";
import { IoMusicalNote } from "react-icons/io5";
import { FaMicrophone } from "react-icons/fa";
import { makeAuthenticatedGETRequest } from "../../services/serverHelper";
import { toast } from "react-toastify";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setAccessToken, setRefreshToken } from "../../reducer/slices/authSlice";
import { patronProfilePoints } from "../../services/apis";
import Patron_Navbar from "../Patron_Navbar";


const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://api.ekalakaar.com';

export default function PatronArtistProfile() {
  const [dateState, setDateState] = useState([]);
  const [artdata, setArtData] = useState({});
  const [localImages, setLocalImages] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('hero');
  const token = localStorage.getItem("accessToken");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {id} = useParams();

  const getFullImageUrl = (imageValue) => {
    if (!imageValue) return "/default-avatar.png";
    let raw = String(imageValue).replace(/[\u0000-\u001F\u007F]+/g, "").trim();
    if (!raw) return "/default-avatar.png";
    if (raw.startsWith("blob:")) return raw;
    if (/^https?:\/\//i.test(raw)) return raw;
    if (raw.startsWith("//")) return "https:" + raw;
    let cleaned = raw
      .replace(/^\/+/, "")
      .replace(/^public\/images\//i, "")
      .replace(/^public\/uploads\//i, "")
      .replace(/^uploads\/performance\//i, "")
      .replace(/^uploads\//i, "")
      .replace(/^images\//i, "")
      .replace(/^api\/v1\/images\//i, "")
      .replace(/^api\/images\//i, "")
      .replace(/^https?:\/\/api\.ekalakaar\.com\/api\/v1\/images\//i, "")
      .replace(/^https?:\/\/api\.ekalakaar\.com\/uploads\/performance\//i, "")
      .replace(/^https?:\/\/api\.ekalakaar\.com\//i, "")
      .trim();
    const envBase = process.env.REACT_APP_BASE_URL || "https://api.ekalakaar.com";
    const API_HOST = String(envBase).replace(/\/api(\/v?1)?(\/.*)?$/i, "").replace(/\/+$/, "");
    return `${API_HOST}/images/${cleaned}`;
  };

  
  // const getartist = async () => {
  //   try {
  //     const artistData = await makeAuthenticatedGETRequest(
  //       `${BASE_URL}/artists/profile`,
  //       token
  //     );
  //     setArtData(artistData.data);
  //     const dates = artistData?.data?.appliedOpportunities?.map(
  //       (op) => op?.performanceDate
  //     );
  //     setDateState(dates || []);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };


   const getartist = async () => {
    try {
      const artistData = await makeAuthenticatedGETRequest(
        patronProfilePoints.GET_SINGLE_ARTIST_DATA_API + `${id}`,
        token
      );
      console.log(artistData.data);
      setArtData(artistData.data);
      const dates = artistData?.data?.appliedOpportunities?.map(
        (op) => op?.performanceDate
      );
      setDateState(dates || []);
    } catch (error) {
      console.error(error);
    }
  };


  
  useEffect(() => {
    getartist();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
      const sections = ['hero', 'about', 'expertise', 'performance', 'gallery', 'awards', 'contact'];
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom >= 100) {
            setActiveSection(section);
            break;
          }
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <>
      <Patron_Navbar />
      <div className="sidebar-wrapper">
        
        <div className="modern-portfolio-wrapper">
          {/* Hero Section */}
          <section id="hero" className="hero-section">
            <div className="hero-decoration"></div>
            <div className="hero-content">
              <div className="hero-text">
                <span className="hero-label">Professional Artist</span>
                <h1 className="hero-title">
                  Hi, I'm <span className="highlight">{artdata?.personalInfo?.firstName || "Artist"}</span>
                  <br />
                  {`${artdata?.artInfo?.artName[0]} artist` || "Professional Artist"}
                </h1>
                <p className="hero-subtitle">
                  {artdata?.artInfo?.aboutArt.length > 0 ? artdata?.artInfo?.aboutArt : "Passionate about creating memorable artistic experiences"}
                </p>
                
                <div className="hero-stats">
                  <div className="hero-stat">
                    <div className="hero-stat-number">{artdata?.performanceInfo?.totalPerfs || 0}+</div>
                    <div className="hero-stat-label">Performances</div>
                  </div>
                  <div className="hero-stat">
                    <div className="hero-stat-number">{artdata?.awardsInfo?.totalAwards || 0}</div>
                    <div className="hero-stat-label">Awards Won</div>
                  </div>
                  <div className="hero-stat">
                    <div className="hero-stat-number">{artdata?.personalInfo?.languages?.length || 0}</div>
                    <div className="hero-stat-label">Languages</div>
                  </div>
                </div>

                <div className="hero-actions">
                  <button className="btn-primary" onClick={() => scrollToSection('contact')}>
                    Contact Me <FaArrowRight />
                  </button>
                  <button className="btn-secondary" onClick={() => scrollToSection('gallery')}>
                    View Gallery <FaImage />
                  </button>
                </div>

                <div className="hero-social">
                  {artdata?.socialLinks?.instagram && (
                    <a href={artdata.socialLinks.instagram} target="_blank" rel="noopener noreferrer" className="social-btn"><FaInstagram /></a>
                  )}
                  {artdata?.socialLinks?.facebook && (
                    <a href={artdata.socialLinks.facebook} target="_blank" rel="noopener noreferrer" className="social-btn"><FaFacebook /></a>
                  )}
                  {artdata?.socialLinks?.youtube && (
                    <a href={artdata.socialLinks.youtube} target="_blank" rel="noopener noreferrer" className="social-btn"><FaYoutube /></a>
                  )}
                  {artdata?.socialLinks?.linkedin && (
                    <a href={artdata.socialLinks.linkedin} target="_blank" rel="noopener noreferrer" className="social-btn"><FaLinkedin /></a>
                  )}
                  {artdata?.socialLinks?.twitter && (
                    <a href={artdata.socialLinks.twitter} target="_blank" rel="noopener noreferrer" className="social-btn"><FaTwitter /></a>
                  )}
                </div>
              </div>

              <div className="hero-image">
                <div className="hero-image-wrapper">
                  {/* <img 
                    src={getFullImageUrl(artdata?.personalInfo?.avatar?.url)} 
                    alt={`${artdata?.personalInfo?.firstName}`}
                    onError={(e) => { e.target.src = "/default-avatar.png"; }}
                  /> */}
                </div>
                <div className="hero-image-badge">
                  <div className="badge-icon"><FaTrophy /></div>
                  <div className="badge-text">Excellence in</div>
                  <div className="badge-value">{artdata?.artInfo?.artCategory?.[0] || "Arts"}</div>
                </div>
              </div>
            </div>
          </section>

        <section id="about" className="section about-section">
            <div className="section-header">
              <h2 className="section-title">About Me</h2>
            </div>
            <div className="about-content">
              <div className="about-info">
                <div className="info-group">
                  <h3><FaUser /> Personal Details</h3>
                  <p><strong>Age:</strong> {artdata?.personalInfo?.age || "N/A"}</p>
                  <p><strong>Gender:</strong> {artdata?.personalInfo?.gender || "N/A"}</p>
                  <p><strong>Languages:</strong> {artdata?.personalInfo?.languages?.join(", ") || "N/A"}</p>
                </div>
                <div className="info-group">
                  <h3><FaMicrophone /> Art Specialization</h3>
                  <p><strong>Category:</strong> {artdata?.artInfo?.artCategory?.join(", ") || "N/A"}</p>
                  <p><strong>Art Name:</strong> {artdata?.artInfo?.artName?.join(", ") || "N/A"}</p>
                  <p><strong>Type:</strong> {artdata?.artInfo?.artType?.join(", ") || "N/A"}</p>
                </div>
                <div className="info-group">
                  <h3><FaEnvelope /> Contact Information</h3>
                  <p><strong>Email:</strong> {artdata?.personalInfo?.email || "N/A"}</p>
                  <p><strong>Phone:</strong> {artdata?.personalInfo?.contactNumber?.countryCode} {artdata?.personalInfo?.contactNumber?.number || "N/A"}</p>
                  <p><strong>Location:</strong> {artdata?.address?.city}, {artdata?.address?.state}, {artdata?.address?.pincode}</p>
                </div>
              </div>
            </div>
          </section>


          {/* Expertise Section */}
          <section id="expertise" className="section expertise-section">
            <div className="section-header">
              <h2 className="section-title">My Expertise</h2>
            </div>
            <div className="expertise-grid">
              <div className="expertise-card">
                <div className="expertise-icon"><IoMusicalNote /></div>
                <h3>Performance Art</h3>
                <p>Delivering captivating performances that resonate with audiences.</p>
              </div>
              <div className="expertise-card">
                <div className="expertise-icon"><FaStar /></div>
                <h3>Award Winning</h3>
                <p>Recognized excellence with {artdata?.awardsInfo?.totalAwards || 0} prestigious awards.</p>
              </div>
              <div className="expertise-card">
                <div className="expertise-icon"><FaGlobe /></div>
                <h3>Cultural Ambassador</h3>
                <p>Representing traditional art forms on national stages.</p>
              </div>
            </div>
          </section>

          {/* Performance Section */}
          <section id="performance" className="section">
              <div className="section-header">
              <h2 className="section-title">Excellence</h2>
            </div>
            <div className="performance-highlight">
              <div className="performance-content">
                <div className="performance-text">
                  <h3>Performance Excellence</h3>
                  <p>{artdata?.performanceInfo?.highlights || "Dedicated to delivering exceptional performances."}</p>
                  <p style={{marginTop: '1rem'}}><strong>Peak Performance:</strong> {artdata?.performanceInfo?.peakPerf || "N/A"}</p>
                </div>
                <div className="performance-stats">
                  <div className="perf-stat-card">
                    <div className="number">{artdata?.performanceInfo?.totalPerfs || 0}</div>
                    <div className="label">Total Performances</div>
                  </div>
                  <div className="perf-stat-card">
                    <div className="number">{artdata?.awardsInfo?.totalAwards || 0}</div>
                    <div className="label">Awards Received</div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Gallery Section */}
          <section id="gallery" className="section gallery-section">
            <div className="section-header">
              <h2 className="section-title">Performance Gallery</h2>
            </div>
            <div className="gallery-grid">
              {[...(artdata?.performanceInfo?.perfImgs || []), ...localImages].map((img, i) => {
                let imageUrl = typeof img === 'string' ? getFullImageUrl(img) : (img.uploadedUrl ? getFullImageUrl(img.uploadedUrl) : img.preview);
                return (
                  <div key={i} className="gallery-item">
                    <img src={imageUrl} alt={`Performance ${i + 1}`} onError={(e) => { e.target.style.display = 'none'; }} />
                    <div className="gallery-overlay">
                      <span className="gallery-overlay-text">Performance {i + 1}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </section>

          {/* Awards Section */}
          <section id="awards" className="section awards-section">
            <div className="section-header">
              <h2 className="section-title">Awards & Honors</h2>
            </div>
            <div className="awards-showcase">
              <div className="awards-visual">
                <div className="award-circle-large">
                  <div className="award-number">{artdata?.awardsInfo?.totalAwards || 0}</div>
                  <div className="award-label">Awards</div>
                </div>
              </div>
              <div className="awards-list">
                <div className="award-item">
                  <h4><FaTrophy /> Highest Level Achieved</h4>
                  <p>{artdata?.awardsInfo?.level || "N/A"}</p>
                </div>
                <div className="award-item">
                  <h4><FaStar /> Award Highlights</h4>
                  <p>{artdata?.awardsInfo?.highlights || "Recognition for outstanding contributions."}</p>
                </div>
              </div>
            </div>
          </section>

          {/* -------------------- UPDATED CONTACT SECTION -------------------- */}
          <section id="contact" className="section contact-section">
            <div className="section-header">
              <h2 className="section-title">Get In Touch</h2>
              <h2 className="section-title">Performance Videos</h2>
            </div>

            <div className="contact-content">
              {/* LEFT COLUMN: Contact Info */}
              <div className="contact-info">

              <div className="contact-card" style={{ display: "flex", alignItems: "center", gap: "40px" }}>
                  <FaEnvelope style={{ fontSize: "22px", color: "#AD2F3B" }} />
                    <div className="contact-details">
                    <h4>Email</h4>
                      <p>{artdata?.personalInfo?.email || "N/A"}</p>
                      </div>

              </div>

                <div className="contact-card" style={{ display: "flex", alignItems: "center", gap: "40px" }}>
                <FaPhone style={{ fontSize: "20px", color: "#AD2F3B" }} />
                <div className="contact-details">
                  <h4>Phone</h4>
                    <p>
                  {artdata?.personalInfo?.contactNumber?.countryCode}{" "}
                  {artdata?.personalInfo?.contactNumber?.number || "N/A"}
                  </p>
                </div>
                
                </div>

              <div className="contact-card" style={{ display: "flex", alignItems: "center", gap: "40px" }}>
    
                        <MdLocationOn style={{ fontSize: "24px", color: "#AD2F3B" }} />

    <div className="contact-details">
      <h4>Location</h4>
      <p>
        {artdata?.address?.city && `${artdata.address.city}, `}
        {artdata?.address?.state && `${artdata.address.state}, `}
        {artdata?.address?.pincode || "N/A"}
      </p>
    </div>
              </div>
              </div>

              {/* RIGHT COLUMN: Videos (Redesigned Button Style) */}
              <div className="contact-videos-column">
                <h3 className="video-section-header">
                  <FaFilm className="video-header-icon" /> Videos
                </h3>
                
                <div className="video-list-modern">
                  {(artdata?.performanceInfo?.perfVideos || []).length === 0 && (
                    <p>No videos added yet.</p>
                  )}

                  {(artdata?.performanceInfo?.perfVideos || []).map((video, index) => {
                    const url = typeof video === "string" ? video : video?.url;
                    const title = typeof video === "string" 
                      ? `Performance Video ${index + 1}` 
                      : video?.title || `Performance Video ${index + 1}`;
                    
                    if (!url) return null;

                    return (
                      <a 
                        key={index} 
                        href={url} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="video-card-modern"
                      >
                        <div className="video-card-left">
                          <div className="video-icon-circle">
                            <FaPlay />
                          </div>
                          <span className="video-title-text">{title}</span>
                        </div>
                        
                        <div className="video-card-right">
                          <span>Open in new tab &rarr;</span>
                        </div>
                      </a>
                    );
                  })}
                </div>
              </div>
              {/* End Right Column */}

            </div>
          </section>

         
        </div>
      </div>
    </>
  );
}